import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { ServiceCRUD } from '../../../shared/crud/ServiceCRUD';
import { environment } from '../../../../environments/environment';

@Injectable()
export class OperacoesBloqueadasService extends ServiceCRUD {
  private baseUrlService: string;
  private url: string;

  constructor(public httpClient: HttpClient, router: Router) {
    super(httpClient, router);
    this.baseUrlService = environment.URL_API;
  }

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': JSON.parse(sessionStorage.getItem('currentUser')).token
    })
  };

  protected getURL(): string {
    return this.url;
  }

  private definirURLFiltroDealers() {
    this.url = `${this.baseUrlService}/filtro/dealer`;
  }

  public getFiltroDealers(): any {
    this.definirURLFiltroDealers();
    return this.get([]);
  }

  public getDados(
    data_inicial?: any,
    data_final?: any,
    dealer?: any,
    filter?: any): Observable<any> {
    return this.httpClient.get<any>(`${this.baseUrlService + '/operacoes_bloqueadas'}`, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': JSON.parse(sessionStorage.getItem('currentUser')).token
      }),
      params: new HttpParams()
        .set('data_inicial', data_inicial.toString())
        .set('data_final', data_final.toString())
        .set('codDealer', dealer.toString())
    });
  }

  public getDadosAnaliticos(
    codigo?: any,
    data_inicial?: any,
    data_final?: any,
    filter?: any): Observable<any> {
    return this.httpClient.get<any>(`${this.baseUrlService + '/operacoes_bloqueadas/analitico'}`, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': JSON.parse(sessionStorage.getItem('currentUser')).token
      }),
      params: new HttpParams()
        .set('data_inicial', data_inicial.toString())
        .set('data_final', data_final.toString())
        .set('codDealer', codigo.toString())
    });
  }

  public reenviar(id: number): Observable<any> {
    return this.httpClient.put<any>(`${this.baseUrlService}/operacoes_bloqueadas/${id}/reenviar`, {}, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': JSON.parse(sessionStorage.getItem('currentUser')).token
      })
    });
  }

}
